import { CaseDocumentAdmin } from "pwapi";

import { CaseAdminDetail } from "../../reducers/admin/adminCaseReducer";
import {
  ADMIN_CASE_DOCUMENT_REQUEST,
  ADMIN_DELETE_CASE_DOCUMENT_REQUEST,
  ADMIN_OPEN_CASE_DOCUMENT,
  ADMIN_SET_CASE_DOCUMENT,
  ADMIN_UPDATE_CASE_DOCUMENT_REQUEST,
  ADMIN_UPLOAD_CASE_DOCUMENT_REQUEST,
} from "../adminConstants";

export const setDocument = (payload: CaseDocumentAdmin | null = null) => {
  return {
    type: ADMIN_SET_CASE_DOCUMENT,
    payload,
  };
};

export const fetchDocument = (payload: number) => {
  return {
    type: ADMIN_CASE_DOCUMENT_REQUEST,
    payload,
  };
};

export const openAdminDocument = (payload: number) => {
  return {
    type: ADMIN_OPEN_CASE_DOCUMENT,
    payload,
  };
};

export const updateAdminDocument = (
  newDocument: FormData,
  closePanelFn?: Function
) => {
  return {
    type: ADMIN_UPDATE_CASE_DOCUMENT_REQUEST,
    payload: {
      document: newDocument,
      closePanelFn: closePanelFn,
    },
  };
};

export const uploadAdminCaseDocument = (
  payload: FormData,
  closePanelFn?: Function,
  adminCase?: CaseAdminDetail
) => {
  return {
    type: ADMIN_UPLOAD_CASE_DOCUMENT_REQUEST,
    payload: {
      document: payload,
      closePanelFn: closePanelFn,
      adminCase: adminCase,
    },
  };
};

export const deleteAdminCaseDocument = ({
  id,
  onClose,
}: {
  id: number;
  onClose?: Function;
}) => {
  return {
    type: ADMIN_DELETE_CASE_DOCUMENT_REQUEST,
    payload: { id, closePanelFn: onClose },
  };
};
